import { useSoftwareProjectTheming } from '@atlassian/jira-project-theme-providers/src/controllers/software-theme/index.tsx';
import {
	getIsSoftwareThemingEnabled,
	getIsSoftwareThemingM2Enabled,
} from '@atlassian/jira-project-theme-providers/src/utils/getIsSoftwareThemingEnabled.tsx';
import { useBoardSelector } from '../../../state/index.tsx';
import { shouldRenderSwimlaneSelector } from '../../../state/selectors/board/board-selectors.tsx';
import { getSwimlaneMode } from '../../../state/selectors/swimlane/swimlane-mode-selectors.tsx';

export const useHasSwimlanes = () => {
	const { hasSoftwareTheming } = useSoftwareProjectTheming();
	const swimlaneMode = useBoardSelector(getSwimlaneMode);
	const shouldRenderSwimlane = useBoardSelector(shouldRenderSwimlaneSelector);

	if (!getIsSoftwareThemingEnabled() || !hasSoftwareTheming) {
		return false;
	}
	if (getIsSoftwareThemingM2Enabled() && hasSoftwareTheming) {
		return shouldRenderSwimlane;
	}

	// Clean me up when cleaning up getIsSoftwareThemingM2Enabled()
	if (!!swimlaneMode && swimlaneMode !== 'NO_SWIMLANE') {
		return true;
	}
	return false;
};
